<template>
  <section class="workspace__tool workspace-zone">
    <!-- Info Zone -->
    <div class="workspace-zone--info">
      <!-- Mission + Hint -->
      <div class="workspace-zone--info--content">
        <h1 class="workspace-zone__label workspace-zone__label--mission">미션</h1>

        <!-- Mission text-->
        <article class="workspace-zone--info__mission">
          <div v-html="missionText"></div>
        </article>

        <!-- 미션 다시보기-->
        <span class="workspace-zone__btn__wrap">
                <button class="workspace-zone__label workspace-zone__label--reshow workspace-zone__btn"
                        v-on:click="reshowMission">미션<br>다시 보기</button>
          <!-- 힌트 보기-->
                <button class="workspace-zone__label workspace-zone__label--hint workspace-zone__btn"
                        v-on:click="showHintPopup">힌트</button>
            </span>
      </div>

      <!-- ETC -->
      <div class="workspace-zone--info--controller">
        <div class="workspace-zone__divider--block">
          <h1 class="workspace-zone__label workspace-zone__label--info workspace-zone__label--info--non-count">블록 꾸러미</h1>
        </div>
        <h1 class="workspace-zone__label workspace-zone__label--info">블록 조립소 : {{workCount}} / {{maxWorkCount}}</h1>
        <div class="workspace-zone__btn__wrap workspace-zone__btn__wrap--space">
          <button class="workspace-zone__label--small workspace-zone__btn workspace-zone__btn--small workspace-zone__label--retry"
                  v-on:click="missionRetry">다시 시작</button>
          <button v-if="!isJb" class="workspace-zone__label--small workspace-zone__btn workspace-zone__btn--small workspace-zone__label--codeview"
                  v-on:click="showUserCode">코드 보기</button>
        </div>
      </div>
    </div>

    <!-- Blockly Zone -->
    <div class="workspace-zone--blockly__zone">
      <!-- Blockly 조작 방지용 커버 -->
      <div
        v-if="on_game || blckNotAssmbl"
        style="background: rgba(0, 0, 0, 0.7); position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px;user-select: none;z-index: 40"
      />
      <div v-if="blckNotAssmbl" style="font-family: 'Yanolja', sans-serif;
    color: #ffffff;
    font-size: 45px;
    font-weight: bold;
    width: 100%;
    text-align: center;
    position: absolute;
    z-index: 41;
    top: 40%;">명령어 블록을 사용하지 않는 미션입니다.<br>키보드를 사용해 캐릭터를 움직여주세요.</div>

      <!-- Blockly -->
      <div id="blockly-workspace" class="workspace-zone--blockly__wrapper" >
        <div id="blocklyDiv" class="workspace-zone--blockly"></div>
      </div>

      <span v-html="xmlTag"></span>
    </div>
  </section>
</template>

<script>

  import url from 'url'

  import BlocklyManager from '../../assets/js/codmos/BlocklyManager';

  export default {
    name: 'workspaceTemplate',
    props: ['contents_data', 'setup_data', 'block_data', 'on_game', 'studyModalVue', 'blckNotAssmbl', 'isJb'],
    data() {
      return {
        startBlock: 'when_press_start_button',
        missionText: [],
        workCount: 0,
        maxWorkCount: 0,
        isMyCodeOn: false,
        blocklyText: null,
        xmlTag: '<xml id="toolbox" style="display: none"></xml>',
        initBlock: []
      }
    },
    computed: {
      checkCodeTask() {
        return this.isMyCodeOn ? 'on' : '';
      }
    },
    methods: {
      /**
       *  @DESC   스토리 다시 보여주기
       */
      reshowMission() {
        this.callStoryPopup(this.strStoryPopupHeader, this.arrStoryPopup);
      },
      /**
       *  @DESC   스토리 팝업
       */
      callStoryPopup() {
        this.studyModalVue.showStartPopup({
          title: this.strStoryPopupHeader,
          desc: this.arrStoryPopup
        });
      },
      /**
       *  @DESC   힌트 팝업 보여주기
       */
      showHintPopup() {
        this.studyModalVue.showHintPopup(this.arrHintPopup);
      },
      /**
       *  @DESC   미션 다시 하기
       */
      missionRetry() {
        this.studyModalVue.showEtcPopup();
      },
      /**
       *  @DESC   저장하기
       */
      saveUserCode() {
        alert('블록 정보 저장')
        // studyModalVue.setEtcInfo('저장하기', '진행하던 미션정보를 저장하시겠습니까?', '취소하기', '저장하기', true)
        //   .setConfirmEvent(() => {
        //     // # 블록 저장하기
        //     this.blocklyText = Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(Blockly.mainWorkspace));
        //     this.$emit('call_blockly_save', true);
        //   })
        //   .showEtcPopup();
      },
      /**
       *  @DESC   불러오기
       */
      loadUserCode() {
        // studyModalVue.setEtcInfo('불러오기', '저장하신 미션정보를 불러오겠습니까?', '취소하기', '불러오기', true)
        //   .setConfirmEvent(() => {
        //     // # 블록 불러오기
        //     this.$emit('call_blockly_load');
        //   })
        //   .showEtcPopup();
        alert('미션 정보 불러오기')
      },
      /**
       *  @DESC   불러오기
       */
      loadTextToBlocky(textBlock) {
        BlocklyManager.loadTextBlock(Blockly.mainWorkspace, textBlock, this.isJb);
      },
      /**
       *  @DESC   코드 보여주기
       */
      showUserCode() {
        // Blockly.JavaScript.STATEMENT_PREFIX = 'highlightBlock(%1);\n';

        // [#] code 정보 가져오기
        const blockToCode = BlocklyManager.getBlockCode(this.startBlock, "");

        /*[T]*/
        //console.log(blockToCode);

        //TODO
        this.studyModalVue.showCodeView(blockToCode);
      },
      /**
       *  @DESC   데이터 로딩 이후에 이벤트 처리
       */
      async initWorkspace() {
        if (this.isJb) {
          Blockly.Blocks.when_press_start_button = Blockly.Blocks.jb_when_press_start_button;
        }

        const isShowTxbx = !!this.block_data.block.length;
        BlocklyManager.isShowTxbx = isShowTxbx;

        // [#] text 연동
        this.missionText = this.contents_data.quizText;//.replace(/https:\/\/s3.ap-northeast-2.amazonaws.com/, '/codmos/static/assets');
        this.strStoryPopupHeader = this.contents_data.title;
        this.arrStoryPopup = this.contents_data.popup.start;
        this.contents_data.hint.forEach(e => {
          e.hintImage = 'https://www.ebssw.kr' + url.parse(e.hintImage).path
        })
        this.arrHintPopup = this.contents_data.hint;

        // [#] 블럭클리 관련 초기화
        this.initBlock = this.block_data.block.map((bk) => {
          return bk.block;
        });
        this.maxWorkCount = this.block_data.blockMaxCount ? this.block_data.blockMaxCount : '∞';

        // 에디터에서 이름이 지정 된 오브젝트 값 읽기 블록 initBlock과 연동
        if (Array.isArray(this.block_data.blockReadValue)) this.initBlock = this.initBlock.concat(this.block_data.blockReadValue.map((e, i) => ({ text: e, index: i, type: 'read' })));
        // 에디터에서 생성 된 if 블록 initBlock과 연동
        if (Array.isArray(this.block_data.blockIf)) this.initBlock = this.initBlock.concat(this.block_data.blockIf);
        // 에디터에서 내용이 지정 된 변수 값 조절하는 블록 initBlock과 연동
        if (Array.isArray(this.block_data.blockChangeVariable)) this.initBlock = this.initBlock.concat(this.block_data.blockChangeVariable);
        // 에디터에서 지정 된 오브젝트 클릭 블록 initBlock과 연동
        if (Array.isArray(this.block_data.blockClick)) this.initBlock = this.initBlock.concat(this.block_data.blockClick.map((e) => { e.name = `when_click_${e.name}`; return e; }));
        // 에디터에서 지정 된 밀면서 이동하기 블록 initBlock과 연동
        if (Array.isArray(this.block_data.blockPush)) this.initBlock = this.initBlock.concat(this.block_data.blockPush);
        // 에디터에서 지정 된 키보드 블록 initBlock과 연동
        if (Array.isArray(this.block_data.blockKeyboard)) this.initBlock = this.initBlock.concat(this.block_data.blockKeyboard.map((e) => { e.name = `when_press_${e.name}`; return e; }));

        if (
          typeof Blockly.mainWorkspace === 'undefined'
          ||
          Blockly.mainWorkspace == null
        ) {
          await this.setHitBlock(this.setup_data.object, this.setup_data.file);

          // [#] mainWorkspace 새로이 생성
          BlocklyManager.initToolbox("toolbox", this.initBlock, this.block_data.blockVariable);
          BlocklyManager.setBlocklyArea("blocklyDiv", true, true);

          this.setVariable()
          BlocklyManager.updateToolbox('toolbox', this.initBlock, this.block_data.blockVariable);

          const blocklyDiv = document.getElementById('blocklyDiv');

          blocklyDiv.style.width = 0;
          blocklyDiv.style.height = 0;

          Blockly.svgResize(Blockly.mainWorkspace);
        }
        else {
          await this.setHitBlock(this.setup_data.object, this.setup_data.file);

          // [#] mainWorkspace 유지하고 Toolbox Update
          this.setVariable()
          BlocklyManager.updateToolbox('toolbox', this.initBlock, this.block_data.blockVariable);
        }
        Blockly.mainWorkspace.scrollX = parseInt(document.querySelector('svg.blocklyFlyout').getAttribute('width'))
        Blockly.mainWorkspace.translate(Blockly.mainWorkspace.scrollX, 0);
        BlocklyManager.initStartBlock(undefined, Array.isArray(this.block_data.blockMission) ? this.block_data.blockMission[0] : undefined, this.isJb);

        // [#] popup 연동
        // studyModalVue.setHintInfo(this.arrHintPopup);
        // TODO 힌트 팝업 셋팅

        Blockly.mainWorkspace.flyout_.setVisible(isShowTxbx);

        // [#] block count 이벤트 연동
        Blockly.mainWorkspace.addChangeListener(this.onMouseUp);

        Blockly.mainWorkspace.variableMap_.variableBlock = this.block_data.blockVariable || {};

        // [#] start(story) popup 연동
        this.reshowMission();
      },
      setVariable() {
        if (Array.isArray(this.setup_data.variable)) {
          this.setup_data.variable.forEach((e) => {
              const NAME_VARIABLE = Blockly.mainWorkspace.variableMap_.getVariable(e.id, '');
              const VARIABLE = Blockly.mainWorkspace.variableMap_.createVariable(e.id, '', NAME_VARIABLE !== null ? NAME_VARIABLE.id_ : undefined);
              this.initBlock.push({
                  type: 'variable', id: VARIABLE.id_, name: VARIABLE.name, variabletype: "''"
              });
          });
        }
      },
      async setHitBlock(objct, resrce) {
          const hitItems = new Set();
          let existsObstacle = false;

          objct.forEach((e) => {
              const { res } = e;
              const resObj = resrce[res];
              const type = e.type || resObj.type;
              switch (type) {
                  case 'hitItem': {
                      if (!hitItems.has(res)) {
                          hitItems.add(res);
                          this.initBlock.push({
                              type: 'hit',
                              name: `when_hit_item_${res}`,
                              text: resObj.name,
                              src: `/codmos/static/assets/logicong-study-resources/${resObj.min || resObj.src}`,
                              visible: true
                          });
                      }
                      break;
                  }
                  default:
                      break;
              }
          });
        },
      getUsedBlockCount(cb) {
        cb(this.workCount);
      },
      /**
       *  @DESC   워크스페이스 마우스업
       */
      onMouseUp() {
        this.workCount = BlocklyManager.getBlockCount2();
      },
      /**
      * [ Function :: initStartBlock ]
      *
      * @DES :: 블록 초기화 실행 시 동작
      * @IP1 :: null
      * @O.P :: null
      */
      initStartBlock() {
        BlocklyManager.initStartBlock(undefined, Array.isArray(this.block_data.blockMission) ? this.block_data.blockMission[0] : undefined, this.isJb);
      }
    },
    mounted() {
      this.$emit('load');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/stage/StagePartialWorkspace.vue